import {Component, Input, OnInit} from '@angular/core'
import { FormGroup } from '@angular/forms'
@Component({
  selector: 'dmmp-form-radio',
  templateUrl: './radio.component.html',
})
export class RadioComponent implements OnInit {
  @Input() field
  @Input() identifier
  @Input() group: FormGroup

  constructor() {
  }

  ngOnInit() {
  }
}
